export default __webpack_public_path__ + "static/media/enghien10.caa9c424.jpg";